export default __webpack_public_path__ + "img/logo-puroak.asset.48f350c7.png";